// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1a5cb09a","453":"c60ed7d5","455":"81e37c47","977":"1235bcbb"}[chunkId] + ".chunk.js";
};